import React, { useRef, useMemo } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import Card from './Card';
import EmptyState from './EmptyState';
import Loader from '../../../common/Loader';
import ChatMembersModal from './ChatMembersModal';
import ResultsDetailsModal from '../ResultsDetailsModal';
import LabTestHistoryModal from '../LabTestHistoryModal';
import { useLazyLoad } from '../../../../hocs/useLazyLoad';

import styles from './index.styl';

const DataList = ({
  data,
  pending,
  category,
  loadMore,
  activeTab,
  formatMessage,
  withPagination,
}) => {
  const rootRef = useRef();
  const isNotEmpty = Boolean(data.length);

  const {
    showList,
    showLoader,
    showPaginationLoader,
    showEmptyState,
  } = useMemo(
    () => ({
      showLoader: pending && !isNotEmpty,
      showPaginationLoader: pending && withPagination && isNotEmpty,
      showEmptyState: !pending && !isNotEmpty,
      showList:
        (!pending && isNotEmpty) || (withPagination && pending && isNotEmpty),
    }),
    [pending, isNotEmpty, withPagination],
  );

  const rootStyles = useMemo(
    () => cn(styles.root, { [styles.paginationRoot]: withPagination }),
    [withPagination],
  );

  useLazyLoad({ node: rootRef, loadMore, path: [] });

  return (
    <div className={rootStyles} ref={rootRef}>
      {showLoader && <Loader />}
      {showEmptyState && (
        <EmptyState
          category={category}
          activeTab={activeTab}
          formatMessage={formatMessage}
        />
      )}
      {showList &&
        data.map(card => (
          <Card
            key={card.id}
            entity={card}
            activeTab={activeTab}
            formatMessage={formatMessage}
          />
        ))}
      {showPaginationLoader && (
        <div className={styles.paginationLoader}>
          <Loader />
        </div>
      )}
      <LabTestHistoryModal />
      <ResultsDetailsModal />
      <ChatMembersModal />
    </div>
  );
};

DataList.propTypes = {
  data: PropTypes.array,
  pending: PropTypes.bool,
  loadMore: PropTypes.func,
  category: PropTypes.string,
  activeTab: PropTypes.string,
  formatMessage: PropTypes.func,
  withPagination: PropTypes.bool,
};

export default DataList;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/index.jsx